// src/Provider/SourcesProvider.js
import React, { useEffect } from "react";
import { SkillService } from "../services/SkillService";
import { SourcesStore } from "../store/store_state";
import useAuth from "../Hooks/useAuth";

export default function SourcesProvider({ children }) {
  const {isUserLoggedIn} = useAuth();
  const { sources, isLoading, isLoaded, error } = SourcesStore.useState((s) => ({
    sources: s.sources,
    isLoading: s.isLoading,
    isLoaded: s.isLoaded,
    error: s.error,
  }));

  useEffect(() => {
    const loadSources = async () => {
      try {
        await SkillService.getSkillSourcesV4();
      } catch (error) {
        console.error("Failed to load sources", error);
      }
    };

    if (isUserLoggedIn && sources.length === 0 && !isLoading && !error) {
      loadSources();
    }
  }, [isUserLoggedIn, sources.length, isLoading, error]);

  if (isUserLoggedIn && sources.length === 0 && !isLoaded && !error) {
    return null;
  }

  return children;
}
